import {
  Car,
  Shirt,
  Droplet,
  WashingMachine,
  Beer,
  UtensilsCrossed,
  Flame,
  Wifi,
  Store,
  Lightbulb,
  Wind,
  Users
} from 'lucide-react'
import { Court, ArenaAmenity, getAmenityLabel } from '@/types/arena'
import { H3 } from '@meiuca/ui-components'
import { modalitiesManager } from '@/managers/modalitiesManager'

interface CourtsSectionProps {
  courts: Court[]
}

function getAmenityIcon(amenity: ArenaAmenity) {
  const icons = {
    [ArenaAmenity.PARKING]: Car,
    [ArenaAmenity.LOCKER_ROOM]: Shirt,
    [ArenaAmenity.SHOWER]: Droplet,
    [ArenaAmenity.BATHROOM]: WashingMachine,
    [ArenaAmenity.BAR]: Beer,
    [ArenaAmenity.RESTAURANT]: UtensilsCrossed,
    [ArenaAmenity.BBQ]: Flame,
    [ArenaAmenity.WIFI]: Wifi,
    [ArenaAmenity.STORE]: Store,
    [ArenaAmenity.LIGHTING]: Lightbulb,
    [ArenaAmenity.AIR_CONDITIONING]: Wind,
    [ArenaAmenity.BLEACHERS]: Users
  }
  return icons[amenity]
}

export function CourtsSection({ courts }: CourtsSectionProps) {
  if (!courts || courts.length === 0) {
    return null
  }

  return (
    <section>
      <H3 className="mb-4">Quadras e campos</H3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courts.map((court) => (
          <div
            key={court.id}
            className="rounded-lg border border-border-light bg-background-white hover:shadow-md transition-shadow overflow-hidden"
          >
            {/* Photo */}
            {court.photo && (
              <div className="aspect-video w-full overflow-hidden">
                <img
                  src={court.photo}
                  alt={court.name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}

            <div className="p-4">
              {/* Name */}
              <h4 className="font-semibold text-text-primary mb-3">{court.name}</h4>

              {/* Modalities */}
              {court.modalities && court.modalities.length > 0 && (
                <div className="mb-3">
                  <span className="text-xs text-text-secondary mb-1 block">Modalidades:</span>
                  <div className="flex flex-wrap gap-1">
                    {court.modalities.map((modality) => (
                      <span
                        key={modality}
                        className="px-2 py-1 bg-brand-primary/10 text-brand-primary text-xs font-medium rounded-full"
                      >
                        {modalitiesManager.getModalityDescription(modality)}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Amenities */}
              {court.amenities && court.amenities.length > 0 && (
                <div>
                  <span className="text-xs text-text-secondary mb-2 block">Facilidades:</span>
                  <div className="flex flex-wrap gap-2">
                    {court.amenities.map((amenity) => {
                      const Icon = getAmenityIcon(amenity)
                      return (
                        <div
                          key={amenity}
                          className="flex items-center gap-1.5 px-2 py-1 bg-background-secondary rounded-md"
                        >
                          <Icon className="w-3.5 h-3.5 text-brand-primary flex-shrink-0" />
                          <span className="text-xs text-text-primary">{getAmenityLabel(amenity)}</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
